import { getValue } from "../../utils/object.utils";

export const transformTransportListTableData = (
  transportsList: Array<any>
): any[] => {
  const transformDatForTable = transportsList.map((transport: any): any => {
    return {
      id: getValue(transport, "id"),
      routeName: getValue(transport, "route_name"),
      transportCode: getValue(transport, "transport_code"),
      vehicleNo: getValue(transport, "vehicle_no"),
      driverName: getValue(transport, "driver_name"),
      driverLicense: getValue(transport, "driver_license"),
      driverContact: getValue(transport, "driver_contact"),
    };
  });

  return transformDatForTable;
};
